import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Card, Col, Divider, Row, Typography } from 'antd';

import AiIcon from '../../../../../components/AiIcon';

import { useHomeMessageId } from '../../../hooks/useHomeMessageId';

const { Title } = Typography;

const legacyCards = [
  {
    titleKey: 'legacy.manual.title',
    icon: 'legacy-manualTrading',
    variant: 'manual',
    items: [
      'legacy.manual.item.parameters',
      'legacy.manual.item.humanFactor',
      'legacy.manual.item.speed',
    ],
    bg: '--icon-legacy-manualTrading-bg',
  },
  {
    titleKey: 'legacy.indicators.title',
    icon: 'legacy-indicatorsTrading',
    variant: 'indicators',
    items: [
      'legacy.indicators.item.analysis',
      'legacy.indicators.item.signals',
    ],
    bg: '--icon-legacy-indicatorsTrading-bg',
  },
];

type LegacyCardProps = {
  titleId: string;
  icon: string;
  variant: string;
  items: string[];
  bg: string;
};

const LegacyCard = ({ titleId, icon, items, variant, bg }: LegacyCardProps) => {
  return (
    <Card
      className={`home-page__legacy-card home-page__legacy-card--${variant}`}
      variant="borderless"
    >
      <AiIcon name={icon} />

      <Title level={3}>
        <FormattedMessage id={titleId} />
      </Title>
      <ul>
        {items.map((item) => (
          <li key={item}>
            <FormattedMessage id={item} />
          </li>
        ))}
      </ul>
      <div
        className="home-page__card-shape"
        style={{ background: `var(${bg})` }}
        aria-hidden
      />
    </Card>
  );
};

const LegacyCards = () => {
  const homeMessageId = useHomeMessageId();

  return (
    <section className="home-page__legacy">
      <Divider>
        <Title level={2}>
          <FormattedMessage id={homeMessageId('legacy.title')} />
        </Title>
      </Divider>
      <Row className="home-page__legacy-grid" gutter={[30, 30]}>
        {legacyCards.map((card) => (
          <Col xs={24} md={12} key={card.titleKey}>
            <LegacyCard
              titleId={homeMessageId(card.titleKey)}
              icon={card.icon}
              variant={card.variant}
              items={card.items.map((key) => homeMessageId(key))}
              bg={card.bg}
            />
          </Col>
        ))}
      </Row>
    </section>
  );
};

export default LegacyCards;
